import { Modal } from 'v2/ui/utils/useModalToggle'

export const MODAL_KEY = 'DuplicateView'
export type DuplicateViewModalData = {
    view: ViewDto
    onConfirm: (modal: Modal<DuplicateViewModalData>) => Promise<void>
}
